import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { generateCaptcha } from "@/lib/api";

export default function CaptchaField({ value, onChange }) {
  const [pair, setPair] = useState({ a: 0, b: 0 });

  useEffect(() => {
    const p = generateCaptcha();
    setPair(p);
    onChange({ a: p.a, b: p.b, answer: "" });
  }, []);

  const refresh = () => {
    const p = generateCaptcha();
    setPair(p);
    onChange({ a: p.a, b: p.b, answer: "" });
  };

  return (
    <div>
      <Label className="text-lg font-semibold text-[#1A1818] mb-2 block">
        Verificación de seguridad
      </Label>
      <div className="flex items-center gap-3">
        <span className="font-serif text-xl font-bold text-[#1A1818] bg-[#F3F1EF] px-4 py-3 rounded-lg border-2 border-[#D1C9C1] min-w-[120px] text-center">
          {pair.a} + {pair.b} = ?
        </span>
        <Input
          data-testid="captcha-input"
          type="number"
          inputMode="numeric"
          value={value?.answer ?? ""}
          onChange={(e) =>
            onChange({ a: pair.a, b: pair.b, answer: e.target.value === "" ? "" : Number(e.target.value) })
          }
          placeholder="Respuesta"
          className="h-14 text-lg border-2 border-[#D1C9C1] focus-visible:border-[#8A3A33] flex-1"
        />
        <Button
          type="button"
          variant="outline"
          onClick={refresh}
          className="h-14 w-14 border-2 border-[#D1C9C1]"
          data-testid="captcha-refresh"
          aria-label="Generar nuevo CAPTCHA"
        >
          <RefreshCw className="w-5 h-5" />
        </Button>
      </div>
    </div>
  );
}
